import { render, staticRenderFns } from "./Denounce-views.vue?vue&type=template&id=4d314454&scoped=true"
import script from "./Denounce-views.vue?vue&type=script&lang=js"
export * from "./Denounce-views.vue?vue&type=script&lang=js"
import style0 from "./Denounce-views.vue?vue&type=style&index=0&id=4d314454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d314454",
  null
  
)

export default component.exports